export default __webpack_public_path__ + "static/media/Sunset-Edited-480px-147px.jpg.d4d0a132.webp";